// extracted by mini-css-extract-plugin
export default {"container":"Console_container__E+B6J","message":"Console_message__X99yA"};